import React, { Component } from 'react';
import TextBlock from './TextBlock';

class Caption extends Component {
  render(){
    return(
        <div className="container small extra-padding-bottom">
          <TextBlock text={this.props.captionText} captionMode/>
        </div>
    );
  }
}

export default Caption;



// WEBPACK FOOTER //
// ./src/layout/Caption.js